import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Layout from './component/Layout';
import Navbar from './component/Navbar';


import 'bootstrap/dist/css/bootstrap.min.css';


import './App.css';



import Gallery from './component/Gallery';
import Manish from './pages/Manish';
import Clinic from './pages/Clinic';
import Whychoose from './pages/Whychoose';
import Patientreview from './pages/Patientreview';
import Procedure from './pages/Procedure';
import Endueuro from './Treatments/Endueuro';
import Urooncology from './Treatments/Urooncology';
import Kidney from './Treatments/Kidney';
import Female from './Treatments/Female';
import PediatricUrology from './Treatments/PediatricUrology';
import Reconstructive from './Treatments/Reconstructive';
import Andrology from './Treatments/Andrology';
import GeneralUro from './Treatments/GeneralUro';




function App() {
  return (
    <div className='main'>


      <BrowserRouter >
        
        <Navbar />
        <Routes>
          <Route path="*" element={<Layout />} />
          
          <Route path="/Manish" element={<Manish />} />
          <Route path="/Clinic" element={<Clinic />} />
          <Route path="/Whychoose" element={<Whychoose />} />
          <Route path="/Gallery" element={<Gallery />} />
          <Route path="/Patientreview" element={<Patientreview />} />
          <Route path="/Procedure" element={<Procedure />} />


          <Route path="/Endueuro" element={<Endueuro />} />
          <Route path="/Urooncology" element={<Urooncology />} />
          <Route path="/Kidney" element={<Kidney />} />
          <Route path="/Female" element={<Female />} />
          <Route path="/PediatricUrology" element={<PediatricUrology />} />
          <Route path="/Reconstructive" element={<Reconstructive />} />
          <Route path="/Andrology" element={<Andrology />} />
          <Route path="/GeneralUro" element={<GeneralUro />} />


        </Routes>
      </BrowserRouter>


    </div>
  );
}

export default App;
